import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../../../api/api";
import useRecaptcha from "../../../hooks/useRecaptcha";
import PasswordInput from "../../Shared/Utils/PasswordInput"
import styles from "./resetPasswordAdmin.module.css";

const ResetPasswordAdmin = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { getRecaptchaToken } = useRecaptcha();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!password || !confirmPassword) {
      setError("Please enter both password fields.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const recaptchaToken = await getRecaptchaToken("reset_password");
      if (!recaptchaToken) {
        setError("reCAPTCHA verification failed. Please try again.");
        return;
      }
      await resetPassword(token, password, confirmPassword, recaptchaToken);
      setMessage("Password has been reset successfully.");
      setTimeout(() => navigate("/login"), 2000);
    } catch (error) {
      setError(
        error.response?.data?.error || "Failed to reset password. Try again."
      );
    }
  };

  return (
    <div className={styles.container}>
      <h2>Reset Admin Password</h2>
      {message && <p className={styles.successMessage}>{message}</p>}
      {error && <p className={styles.errorMessage}>{error}</p>}

      <form onSubmit={handleResetPassword} className={styles.form}>
        <label>New Password:</label>
        <PasswordInput
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your new password"
        />

        <label>Confirm Password:</label>
        <PasswordInput
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm your new password"
        />

        <button type="submit">Reset Password</button>
      </form>

      <button
        className={styles.backButton}
        onClick={() => navigate("/login")}
      >
        Back to Login
      </button>
    </div>
  );
};

export default ResetPasswordAdmin;
